/**
* 机构-我的课程列表
*/
<template>
  <div>
    <van-nav-bar placeholder title="课程列表" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
        <div @click="goToPage(null, 3)">
          <span style="color: white">销课记录</span>
        </div>

      </template>
    </van-nav-bar>
  <!--  &lt;!&ndash;搜索&ndash;&gt;
    <div>
      <van-search
              v-model="queryParams.name"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>-->

    <!-- 列表数据 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
              class="my-list"
              v-model="data.bottomLoading"
              :finished="!data.hasMore"
              finished-text="没有更多了"
              @load="onLoad"
      >
        <div class="mykc-box" v-for="item in data.records" :key="item.id">

          <div class="jg-list-top" @click="goToPage(item, 1)">
            <img :src="fileDisplayPrefix + (item.pic ? item.pic.split(',')[0] : '')"/>
            <div class="jg-right">
              <h2><b>{{item.curriculumName}}</b></h2>
              <span>时间: {{item.classTime}}</span>
              <span>教师: {{item.teacherName}}</span>
              <span>课时: {{item.classHour}}/{{item.classHour}}</span>
            </div>
          </div>

          <div class="jg-bottom"  style="justify-content: center">
            <van-button  class="t0 jg-but" type="primary" size="mini" @click="goToPage(item, 2)">销课</van-button>
          </div>
        </div >
      </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>

  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {filterLabelName} from '@/api/common'
  import {queryList} from '@/api/course/institutionCourse'
  import {handlePageData} from '@/utils/common'
  import Utils from "@/js/common/utils";
  import moment from 'moment'

  export default {
    name: 'InstitutionCourse',
    components: {
    },
    data () {
      return {
        moment,
        filterLabelName,
        show: false,
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        queryParams: {},
        identityInfo: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
      }
    },
    computed: {
    },
    created () {
      this.getDict();
      const data = Utils.getLocal('identity') || '';
      this.identityInfo = JSON.parse(data);
      this.getDataList();
    },
    mounted () {
    },
    methods: {
      onSearch() {
        this.getDataList()
      },
      // 加载数据
      onLoad() {
        if (this.data.current > 1 && this.data.hasMore) {
          this.getDataList()
        }
      },
      // 获取列表数据
      getDataList () {
        if (this.data.loading) return;
        this.data.loading = true;
        this.queryParams.identity = this.identityInfo.value;
        this.queryParams.current = this.data.current;
        this.queryParams.size = this.data.size;
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false;
            this.data.topLoading = false;
            this.data.bottomLoading = false
          }, 100)
        })
      },
      // 数据字典
      getDict() {
      },
      // 刷新列表
      refresh () {
        this.reset();
        this.getDataList();
      },
      reset() {
        this.data.current = 1;
        this.data.total = 0;
        this.data.hasMore = true
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      //详情页面跳转 type: 1-详情页面 2-添加页面
      goToPage(item, type){
        switch (type) {
          case 1:
            //详情页面
            this.$router.push({path: `/institutionCourse/detail?id=${item.curriculumId}`});
            break;
          case 2:
            //销课
            this.$router.push({path: `/institutionCourse/sign?id=${item.curriculumId}`});
            break;
          case 3:
            //销课记录
            this.$router.push({path: `/institutionCourse/signRecord`});
            break;
          default:
        }
      }
    }
  }
</script>

<style scoped>
.my-list{
  background: #ffffff;
  padding:10px;
}
.mykc-box{
  /*height:108px;*/
  background: #F4F5F7;
  border-radius:12px;
  margin-bottom: 10px;
}
.jg-right span{
  width: 100%;
  justify-content: space-between;
}
.jg-right span i{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding:10px 6px;
  border-radius:12px;
  position: relative;
  top: -5px;
}
.jg-right span i.t0{
  background: #FF9900;
}
.jg-right span i.t1{
  background: #66C779;
}
.jg-right span i.t2{
  background: #66C779;
}
.jg-right span i.t3{
  background: #A37FFF;
}
.jg-right span i.t4{
  background: #A7A7A7;
}
.jg-right span i.t5{
  background: #A7A7A7;
}
.jg-bottom{
  padding-bottom: 10px;
}
.jg-bottom i.jg-but{
  margin-bottom: 10px;
}
</style>
